import { Tooltip } from 'components/Tooltip';
import { MixedEvent, ParcelEvent } from '@pperform/pp-data-mappers';
import { isNotEmpty } from '@pperform/pp-utils/object';
import { useTranslation } from 'react-i18next';
import { usePTPConfigContext } from 'GlobalConfig.context';
import { InfoIcon } from '../TrackingTimeline.styles';
import { VISIBLE_ADDITIONAL_INFO } from '../TrackingTimeline.constant';
import { AdditionalInfo } from './AdditionalInfo';

interface EventInfoProps {
  event: MixedEvent | ParcelEvent;
}

export const EventInfo = ({ event }: EventInfoProps): JSX.Element => {
  const { t } = useTranslation();
  const {
    trackingDetailsBox: { shouldShowAdditionalInfoTooltip },
  } = usePTPConfigContext();

  const hasAdditionalInfo =
    !!event.carrier ||
    ('additionalParams' in event && isNotEmpty(event.additionalParams));

  if (!shouldShowAdditionalInfoTooltip || !hasAdditionalInfo) {
    return null;
  }

  const tooltipId = `event-info-tooltip-${event.id}`;

  return (
    <>
      <InfoIcon
        role="img"
        tabIndex={0}
        data-tooltip-id={tooltipId}
        data-testid={`info-icon-${event.id}`}
      />

      <Tooltip
        id={tooltipId}
        render={() => (
          <div id={`tooltip-${event.id}`}>
            <span className="sr-only">{t('ALT_TEXT_INFO_TOOLTIP_ICON')}</span>
            {event.carrier?.name && (
              <AdditionalInfo name={t('carrier')} value={event.carrier.name} />
            )}
            {'additionalParams' in event &&
              isNotEmpty(event.additionalParams) &&
              Object.keys(event.additionalParams)
                .filter(
                  (key) =>
                    event.additionalParams[key] &&
                    VISIBLE_ADDITIONAL_INFO.indexOf(key) !== -1,
                )
                .map((key) => (
                  <AdditionalInfo
                    key={key}
                    name={t(key)}
                    value={event.additionalParams[key]}
                  />
                ))}
          </div>
        )}
      />
    </>
  );
};
